import React from 'react';
import { Well, Row, Col, ControlLabel, FormControl, HelpBlock } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { formatDate } from '../../../shared/utils/date';
import find from 'lodash/find';
import some from 'lodash/some';
import SmallLoader from '../../../components/SmallLoader';

const manifestRoutesContainsAbnormalityRoute = (manifestRoutes, abnormality) => {
    return some(manifestRoutes, ['runId', abnormality.runId]);
};

const getRunDateForSelectedRoute = (selectedRoute, manifestRoutes, abnormality) => {
    const selectedRouteData = find(manifestRoutes, ['runId', selectedRoute]);

    if (selectedRouteData !== undefined) {
        return formatDate(selectedRouteData.runDate);
    } else if (abnormality && abnormality.runId === selectedRoute) {
        return formatDate(abnormality.runDate);
    } else {
        return '-';
    }
};

const getRunSequenceForSelectedRoute = (selectedRoute, manifestRoutes, abnormality) => {
    const selectedRouteData = find(manifestRoutes, ['runId', selectedRoute]);

    if (selectedRouteData !== undefined) {
        return selectedRouteData.runSequence;
    } else if (abnormality && abnormality.runId === selectedRoute) {
        return abnormality.runSequence;
    } else {
        return '-';
    }
};

const RouteInfoGeneric = ({
    abnormality,
    handleRouteChange,
    manifestRoutes,
    routeCode,
    runDate,
    runSeq,
    selectedRoute,
    isFetching,
    errors,
}) => (
    <Well>
        {isFetching && (
            <Row>
                <Col sm={12} style={{ textAlign: 'center' }}>
                    <SmallLoader />
                </Col>
            </Row>
        )}
        {!isFetching && (
            <div>
                <Row style={{ marginBottom: 10 }}>
                    <Col componentClass={ControlLabel} sm={4}>
                        Route code *
                    </Col>
                       {manifestRoutes.length === 0 && routeCode && <Col sm={8}>{routeCode}</Col>}
                                        {manifestRoutes.length === 0 && !routeCode && (
                                                                <Col sm={8}>
                                                                    <FormControl
                                                                        name="routeCode"
                                                                        value={selectedRoute}
                                                                        onChange={handleRouteChange}
                                                                        componentClass="select"
                                                                    >
                                                                    <option value="" disabled >Select a Run</option>


                                                                         <option value=" ">Required run not available in the list</option>
                                                                    </FormControl>

                                                                      {errors && errors.routeCode && manifestRoutes.length === 0 &&(
                                                                            <HelpBlock>
                                                                            <span className="text-danger">{errors.routeCode}</span>
                                                                            </HelpBlock>
                                                                            )}
                                                                </Col>
                                                            )}
                    {manifestRoutes.length > 0 && (
                        <Col sm={8}>
                            <FormControl
                                name="routeCode"
                                value={selectedRoute}
                                onChange={handleRouteChange}
                                componentClass="select"
                            >
                                <option value="" disabled >Select a run</option>
                                {abnormality &&
                                    abnormality.runId &&
                                    !manifestRoutesContainsAbnormalityRoute(
                                        manifestRoutes,
                                        abnormality
                                    ) && (
                                        <option value={abnormality.runId}>
                                            {`${abnormality.routeCode} - ${abnormality.runDate} - ${
                                                abnormality.runSequence
                                            }`}
                                        </option>
                                    )}
                                {manifestRoutes.map(r => (
                                    <option key={r.runId} value={r.runId}>
                                        {`${r.routeCode} - ${r.runDate} - ${r.runSequence}`}
                                    </option>
                                ))}
                                <option value=" ">Required run not available in the list</option>
                            </FormControl>

                             {errors && errors.routeCode && (
                                 <HelpBlock>
                                 <span className="text-danger">{errors.routeCode}</span>
                                 </HelpBlock>
                                 )}
                        </Col>
                    )}
                </Row>

                <Row style={{ marginBottom: 10 }}>
                    <Col componentClass={ControlLabel} sm={4}>
                        Run date
                    </Col>
                    {manifestRoutes.length === 0 && <Col sm={8}>{formatDate(runDate) || '-'}</Col>}
                    {manifestRoutes.length > 0 && (
                        <Col sm={8}>
                            {getRunDateForSelectedRoute(selectedRoute, manifestRoutes, abnormality)}
                        </Col>
                    )}
                </Row>

                <Row>
                    <Col componentClass={ControlLabel} sm={4}>
                        Run sequence
                    </Col>
                    {manifestRoutes.length === 0 && <Col sm={8}>{runSeq || '-'}</Col>}
                    {manifestRoutes.length > 0 && (
                        <Col sm={8}>
                            {getRunSequenceForSelectedRoute(
                                selectedRoute,
                                manifestRoutes,
                                abnormality
                            )}
                        </Col>
                    )}
                </Row>
            </div>
        )}
    </Well>
);

RouteInfoGeneric.propTypes = {
    routeCode: PropTypes.string,
    runSeq: PropTypes.string,
    runDate: PropTypes.string,
};

export default RouteInfoGeneric;
